import { CartI, CommonI, UserDataI } from '.';

/*
 * Common Initial State
 */

export const initialStateProducts = {
   category_id: 0,
   cost_price: 0,
   description: { en: '', es: '' },
   duration: 0,
   id: 0,
   name: { en: '', es: '' },
   order: 0,
   photo: '',
   sell_price: 0,
   sell_price_usd: 0,
   sell_price_eur: 0,
   sell_price_co: 0,
   sell_price_arg: 0,
   sell_price_clp: 0,
   sell_price_pen: 0,
   sell_price_pr: 0,
   sell_price_crc: 0,
   sell_price_fra: 0,
   sell_price_ita: 0,
   sell_price_uy: 0,
   sell_price_py: 0,
   sell_price_sv: 0,
   sell_price_gb: 0,
   sell_price_pl: 0,
   sell_price_il: 0,
   status: false,
   translated_name: '',
};

export const initialStateZone = {
   id: 0,
   factor: 1,
   locality: '',
   travelers: 0,
};

export const commonInitialState: CommonI = {
   cities: [],
   services: [],
   products: [],
   currentZone: initialStateZone,
   currentProduct: initialStateProducts,
   currentService: '',
   citiesIsFetching: false,
   citiesSuccess: false,
   productsIsFetching: false,
   productsSuccess: false,
   servicesIsFetching: false,
   servicesSuccess: false,
};

/*
    CART Initial State
*/
export const cartInitState: CartI = {
   data: {
      products: [],
      discountCode: '',
      wallet: { code: '', type: '', amount: 0 },
      subTotal: 0,
      total: 0,
      user: {
         name: '',
         surName: '',
         email: '',
         phone: '',
         address: '',
         zipCode: '',
         addressMunicipality: '',
         neighboorhood: '',
         addressStreet: '',
         addressExtNumber: '',
         addressIntNumber: '',
         alias: '',
         details: '',
         date: '',
         hour: '',
      },
   },
   cartIsFetching: false,
   cartSuccess: false,
};

/*
    USER Initial State
*/
export const userSchema = {
   birthdate: '',
   conekta_id: '',
   device_token: '',
   email: '',
   face_id: '',
   gender: '',
   id: '',
   lastnames: '',
   name: '',
   photo_uri: '',
   qualification: '',
   token: '',
};

export const userInitState: UserDataI = {
   data: userSchema,
   userIsFetching: false,
   userSuccess: false,
};
